import Seo from "../components/Seo";
import { useI18n } from "../i18n/LanguageProvider";
import { useRegisterAlternates } from "../components/layout/Layout";
import { pagePath, PAGE_SLUGS } from "../config/pages";
import { getStaticPage } from "../data/pages";
import { PageHero, CTABand, Prose } from "../components/Sections";
import { Reveal } from "../components/motion/Reveal";
import { webPageSchema, breadcrumbSchema } from "../lib/schema";
import { Check } from "lucide-react";

export default function StaticPage({ pageKey }) {
  const { t, lang, p } = useI18n();
  const data = getStaticPage(pageKey);
  const alternates = { en: pagePath(pageKey, "en"), fr: pagePath(pageKey, "fr"), de: pagePath(pageKey, "de") };
  useRegisterAlternates(alternates);

  const title = data.title[lang] || data.title.en;
  const path = pagePath(pageKey, lang);
  const crumbs = [{ name: title, to: path }];

  return (
    <>
      <Seo
        title={data.metaTitle[lang] || data.metaTitle.en}
        description={data.metaDesc[lang] || data.metaDesc.en}
        path={path}
        alternates={alternates}
        lang={lang}
        jsonLd={[
          webPageSchema({ name: title, description: data.metaDesc[lang] || data.metaDesc.en, path }),
          breadcrumbSchema([{ name: t.common.home, path: p("home") }, { name: title, path }]),
        ]}
      />
      <PageHero eyebrow={data.title[lang] ? "" : ""} title={title} intro={data.intro[lang] || data.intro.en} crumbs={crumbs} />

      <article className="container-dv py-16 lg:py-20 max-w-3xl">
        {data.sections.map((s, i) => (
          <Reveal key={i} delay={i * 0.04}>
            <section className="mb-10">
              <h2 className="text-2xl sm:text-3xl text-navy mb-4">{s.h[lang] || s.h.en}</h2>
              {s.body && <Prose paragraphs={s.body[lang] || s.body.en} />}
              {s.list && (
                <ul className="space-y-3">
                  {(s.list[lang] || s.list.en).map((li, j) => (
                    <li key={j} className="flex gap-3 text-navy/75">
                      <Check className="mt-1 h-5 w-5 shrink-0 text-turquoise" />
                      <span className="text-base sm:text-lg leading-relaxed">{li}</span>
                    </li>
                  ))}
                </ul>
              )}
            </section>
          </Reveal>
        ))}

        <Reveal>
          <div className="mt-8 rounded-2xl border border-navy/10 bg-mist p-6 text-sm leading-relaxed text-navy/70">
            <strong className="text-navy">{t.common.disclaimerTitle}.</strong> {t.common.disclaimer}
          </div>
        </Reveal>
      </article>

      <CTABand />
    </>
  );
}
